import React from 'react';

const ManlyBandsLawsuit = () => (
    <div>
        <iframe title="manlyBandsLawsuit" src="https://lashbrook-admin-assets.s3.us-west-2.amazonaws.com/PLD0002_DKT+2_Complaint+for+Copyright+Infring%2C+Removal+%26+Falsification+of+Copyright+Mgt+Info%2C+Utah+Unfair+Comp%2C+Violation+of+Lanham+Act%2C+Violation+of+UT+Pattern+%26+Civil%5BEXHIBIT+1-66%5D%5B71%5D.pdf" width="100%" height="100%" style={{ position: 'absolute' }} />
    </div>
);
export default ManlyBandsLawsuit;
